import AsyncForm from '../../form/js/async-form.component';
import template from '../html/success-message-template.hbs';
import TimelineLite from 'gsap/TimelineLite';

export default class EmbeddedResultFormComponent extends AsyncForm {
    constructor() {
        super(...arguments);

        this.resultContainer = this.refs.resultContainer;
        this.resultShowTimeout = null;

        this.tween = new TimelineLite({paused: true});
        this.tween.to(this.resultContainer, 0.5, {opacity: 1, display: 'block'});
    }

    static getRequiredRefs() {
        return ['resultContainer'];
    }

    onSuccess(response) {
        this.renderSuccessMessage(response);
    }

    renderSuccessMessage(response) {
        if (this.resultShowTimeout) {
            clearTimeout(this.resultShowTimeout);
            this.resultShowTimeout = null;
        }
        this.resultContainer.innerHTML = template(response);
        this.tween.play();
        this.resultShowTimeout = setTimeout(this.hideSuccessResult.bind(this), 5000);
    }

    hideSuccessResult() {
        this.tween.reverse();
        this.resultShowTimeout = null;
    }
}



// WEBPACK FOOTER //
// ./app/components/form/js/embedded-result-form.component.js